import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { toast } from "sonner";

export const authClient = createAuthClient({
  // baseURL: window.ENV.BETTER_AUTH_URL
  fetchOptions: {
    onError(e) {
      if (e.error.status === 429) {
        toast.error("Too many requests. Please try again later.");
      }
    },
  },
  plugins: [adminClient()],
});

export const {
  signIn,
  signUp,
  updateUser,
  signOut,
  useSession,
  forgetPassword,
  resetPassword,
  verifyEmail,
  admin,
} = authClient;
